import type { SvgIconProps } from 'types/icon';
import Search from '@mui/icons-material/Search';
import SearchSharp from '@mui/icons-material/SearchSharp';

export const SearchIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Search color={color} {...props} />
);

export const SearchSharpIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <SearchSharp color={color} {...props} />;

export const AiSearchIcon = () => (
  <svg
    width="30"
    height="24"
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M116.252 48.5315L119.061 56.3358C122.185 64.9976 129.005 71.8173 137.667 74.9407L145.472 77.7492C146.176 78.0029 146.176 79.0003 145.472 79.2541L137.667 82.0626C129.005 85.1861 122.185 92.006 119.061 100.667L116.252 108.472C115.999 109.176 115.001 109.176 114.748 108.472L111.939 100.667C108.815 92.0057 101.995 85.186 93.333 82.0626L85.5283 79.2541C84.8239 79.0004 84.8239 78.0029 85.5283 77.7492L93.333 74.9407C101.995 71.8172 108.815 64.9972 111.939 56.3358L114.748 48.5315C115.001 47.8228 115.999 47.8228 116.252 48.5315Z"
      fill="url(#paint0_linear_546_14629)"
    />
    <path
      d="M97.3203 23.2291L98.5203 26.5528C99.8529 30.241 102.757 33.1488 106.45 34.4813L109.774 35.6812C110.075 35.7916 110.075 36.2149 109.774 36.3216L106.45 37.5215C102.761 38.854 99.8529 41.7581 98.5203 45.4499L97.3203 48.7736C97.2098 49.0755 96.7865 49.0755 96.6797 48.7736L95.4797 45.4499C94.1471 41.7618 91.2427 38.854 87.5504 37.5215L84.2264 36.3216C83.9245 36.2112 83.9245 35.7879 84.2264 35.6812L87.5504 34.4813C91.239 33.1488 94.1471 30.2447 95.4797 26.5528L96.6797 23.2291C96.7865 22.9236 97.2135 22.9236 97.3203 23.2291Z"
      fill="url(#paint1_linear_546_14629)"
    />
    <path
      d="M74.8096 90.3125H70.3345L68.7483 88.7831C74.2998 82.3252 77.642 73.9413 77.642 64.821C77.642 44.4845 61.1575 28 40.821 28C20.4845 28 4 44.4845 4 64.821C4 85.1576 20.4845 101.642 40.821 101.642C49.9413 101.642 58.3251 98.2999 64.783 92.7484L66.3125 94.3345V98.8097L94.6363 127.077L103.077 118.636L74.8096 90.3125ZM40.821 90.3125C26.7157 90.3125 15.3295 78.9263 15.3295 64.821C15.3295 50.7158 26.7157 39.3296 40.821 39.3296C54.9263 39.3296 66.3125 50.7158 66.3125 64.821C66.3125 78.9263 54.9263 90.3125 40.821 90.3125Z"
      fill="url(#paint2_linear_546_14629)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_546_14629"
        x1="171"
        y1="61"
        x2="40.5213"
        y2="34.7489"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0656686" stopColor="#6D50FF" />
        <stop offset="0.383285" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_546_14629"
        x1="139"
        y1="16.5"
        x2="19.8589"
        y2="12.4408"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.385054" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_546_14629"
        x1="141"
        y1="48"
        x2="4.55346"
        y2="43.5159"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);
